/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericValueDtoGeometry } from './DiscreteNumericValueDtoGeometry';
import {
    DiscreteNumericValueDtoGeometryFromJSON,
    DiscreteNumericValueDtoGeometryFromJSONTyped,
    DiscreteNumericValueDtoGeometryToJSON,
} from './DiscreteNumericValueDtoGeometry';
import type { DiscreteNumericValueDtoEvaluationType } from './DiscreteNumericValueDtoEvaluationType';
import {
    DiscreteNumericValueDtoEvaluationTypeFromJSON,
    DiscreteNumericValueDtoEvaluationTypeFromJSONTyped,
    DiscreteNumericValueDtoEvaluationTypeToJSON,
} from './DiscreteNumericValueDtoEvaluationType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';

/**
 * 
 * @export
 * @interface NumericValueDto
 */
export interface NumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof NumericValueDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoEvaluationType}
     * @memberof NumericValueDto
     */
    evaluationType?: DiscreteNumericValueDtoEvaluationType | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoGeometry}
     * @memberof NumericValueDto
     */
    geometry?: DiscreteNumericValueDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    min?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    $type?: NumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const NumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericValueDtoTypeEnum = typeof NumericValueDtoTypeEnum[keyof typeof NumericValueDtoTypeEnum];



/**
 * Check if a given object implements the NumericValueDto interface.
 */
export function instanceOfNumericValueDto(value?: unknown): value is NumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericValueDtoTypeEnum)[0];
}

export function NumericValueDtoFromJSON(json: any): NumericValueDto {
    return NumericValueDtoFromJSONTyped(json, false);
}

export function NumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'value': json['value'] == null ? undefined : json['value'],
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'evaluationType': json['evaluationType'] == null ? undefined : DiscreteNumericValueDtoEvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'geometry': json['geometry'] == null ? undefined : DiscreteNumericValueDtoGeometryFromJSON(json['geometry']),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericValueDtoToJSON(value?: NumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'value': value['value'],
        'numericId': value['numericId'],
        'defaultValue': value['defaultValue'],
        'unitAbbreviation': value['unitAbbreviation'],
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value['valueType']),
        'evaluationType': DiscreteNumericValueDtoEvaluationTypeToJSON(value['evaluationType']),
        'decimalPlaces': value['decimalPlaces'],
        'geometry': DiscreteNumericValueDtoGeometryToJSON(value['geometry']),
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'max': value['max'],
        'min': value['min'],
        '$type': value['$type'],
    });
}

